import commonUtils from "@/utils/common.utils";

export default class storeCouponModel {
    constructor(data) {
        this.coupon = data;
        this.add_days = data.add_days;
        this.cheapen = data.cheapen;
        this.coupon_type = data.coupon_type;
        this.coupons_id = data.coupons_id;
        this.del_useable = data.del_useable;
        this.deleted = data.deleted;
        this.description = data.description;
        this.discount = data.discount;
        this.extra_price = data.extra_price;
        this.first_time = data.first_time;
        this.for_product = data.for_product;
        this.free_shipping_type = data.free_shipping_type;
        this.image_id = data.image_id;
        this.is_continue = data.is_continue;
        this.is_unlimit = data.is_unlimit;
        this.issue_min_price = data.issue_min_price;
        this.issued_count = data.issued_count;
        this.last_use_date = data.last_use_date;
        this.point_change = data.point_change;
        this.points = data.points;
        this.product_price = data.product_price;
        this.publish_begin = data.publish_begin ? commonUtils.convertDate(data.publish_begin) : null;
        this.publish_end = data.publish_end ? commonUtils.convertDate(data.publish_end) : null;
        this.publish_scope = data.publish_scope;
        this.quantity_limit = data.quantity_limit;
        this.status = data.status;
        this.store_code = data.store_code;
        this.store_id = data.store_id;
        this.title = data.title;
        this.usage_period_begin = data.usage_period_begin ? commonUtils.convertDate(data.usage_period_begin) : null;
        this.usage_period_end = data.usage_period_end ? commonUtils.convertDate(data.usage_period_end) : null;
        this.use_min_price = data.use_min_price;
        this.use_scope = data.use_scope;
        this.vip_level = data.vip_level;
    }
}